import * as React from 'react';
import { IComponent, IComponentListProps } from '../../helpers';
import { ComponentList, SearchWrapper } from '../../components';
import { Button, ButtonType } from 'office-ui-fabric-react';

export class ComponentRoot extends ComponentList<IComponentListProps> {

	render() {

		let style = `body {
			.conditions-wrapper {
				display: table;
				border-collapse: separate;
				border-spacing: 5px;
				table-layout: fixed;
				min-width: 100%;
				margin-top: 80px;
			}
	
			.conditions {
				display: flex;
				justify-content: center;
				overflow: visible;			}
	
			.conditions > .children {
				display: table-cell;
				margin: 5px;
				min-width: 60rem;
				align-self: start;
				box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
			}

			.children > .children {
				display: flex;
				border: 1px solid #AAA;
				margin: 5px;
				max-width: 60rem;
				min-width: 60rem;
				align-self: center;			
			}
			

			.component-list .component.ui-only {
				margin-left: auto;
				margin-right: auto;
				margin-top: 10px;
				margin-bottom: 10px;
				width: 60%;
			}
		}`;


		let { components, StartId, selectItem, term, suggestions, updateSuggestions, toggleGlobalOutputsDialog, setSearchLocation, searchLocation } = this.props;

		let component: IComponent = components[StartId];
		let children = this.getChildComponents(component);
		// shows the search container if there is nothing at the top of the designer		
		let showSearch: boolean = !children.length;

		return (
			<div className="component-list">
				<style dangerouslySetInnerHTML={{ __html: style }} ></style>

				<div className="component start ms-u-slideDownIn20 anim-1">
					<Button buttonType={ButtonType.icon} icon="Edit" title="Edit global outputs" onClick={toggleGlobalOutputsDialog} />
				</div>

				{showSearch
					&& <SearchWrapper awaitingResults={false}
						debounceDelay={250}
						isCurrentSearchComponent={true}
						labelText={''}
						onResultClick={(key, item) => selectItem(suggestions[key])}
						results={this.getSuggestionsHtml(suggestions)}
						searchTerm={term}
						showResultsWithEmptyTerm={true}
						updateResults={updateSuggestions}
						element={null}
						searchLocation={searchLocation}
						setSearchLocation={setSearchLocation}
						search={true}
						inBranch={false}
						passedSubmissionComponent={false} />
				}
				{children}

			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./source/ts/components/components/component-root.tsx